// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"110":"69954d75","479":"7ea532bf","632":"0b35067b","752":"679f5b38"}[chunkId] + ".chunk.js";
};